/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Sku_Auto_HintInputs */

const vi_packaging_material_sku_auto_hint = /** @type {(inputs: Packaging_Material_Sku_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU sẽ tự sinh theo tên. Nhấn vào ô SKU để chỉnh tay.`)
};

/**

* @param {Packaging_Material_Sku_Auto_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_sku_auto_hint = /** @type {((inputs?: Packaging_Material_Sku_Auto_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Sku_Auto_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_sku_auto_hint(inputs)
});